import React, { Component } from "react";
import { FormError } from "../FormError";
import { FormErrors } from "../FormErrors";
import { Link } from "react-router-dom";
import Loader from "react-loader";
import {
  FormControl,
  FormGroup,
  ControlLabel,
  HelpBlock,
  Checkbox,
  Radio,
} from "react-bootstrap";

class Individual extends Component {
  //Restore the window position 2024 comment AVIT
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  getValidationState(isValid) {
    if (isValid === "" || isValid == null) {
      return null;
    }
    if (isValid) {
      return "success";
    } else {
      return "error";
    }
  }

  handleKeyPress = (event) => {
    if (event.key === "Enter") {
      this.props.handleIndividualValidation(event);
    }
  };

  render() {
    return (
      <div className="container-fluid content-wrapper">
        <div className="row padTop padBottom">
          <div className="container">
            <div className="row">
              <div id="registrationIndividualUserInfo">
                <div className="join-title padBottom col-12">
                  <h1 className="title-common primary">
                    Create An Individual Account
                  </h1>
                  <p className="introText">Step 1 of 2</p>
                </div>
                <div className="col-12">
                  <form
                    onKeyPress={this.handleKeyPress}
                    id="individualRegistrationForm"
                  >
                    <FormErrors
                      formErrors={this.props.genericFormLevelProblems}
                    />
                    <FormGroup>
                      <label>ACCOUNT DETAILS</label>
                    </FormGroup>
                    <FormGroup
                      controlId="formBasicTextFirstName"
                      validationState={this.getValidationState(
                        this.props.firstName.isValid
                      )}
                    >
                      <ControlLabel>
                        First Name <strong className="text-red"> *</strong>
                      </ControlLabel>
                      <FormError
                        id="firstName-error"
                        errorMessage={this.props.firstName.message}
                      />
                      <FormControl
                        name="firstName"
                        type="text"
                        value={this.props.firstName.value}
                        onChange={this.props.handleUserInput}
                        maxLength="30"
                        aria-required="true"
                        aria-describedby="firstName-error"
                        {...(this.props.firstName.hasErrorFocus && {
                          className: "elementFocus",
                        })}
                      />
                    </FormGroup>

                    <FormGroup
                      controlId="formBasicTextLastName"
                      validationState={this.getValidationState(
                        this.props.lastName.isValid
                      )}
                    >
                      <ControlLabel>
                        Last Name <strong className="text-red"> *</strong>
                      </ControlLabel>
                      <FormError
                        id="lastName-error"
                        errorMessage={this.props.lastName.message}
                      />
                      <FormControl
                        name="lastName"
                        type="text"
                        value={this.props.lastName.value}
                        onChange={this.props.handleUserInput}
                        maxLength="30"
                        aria-required="true"
                        aria-describedby="lastName-error"
                        {...(this.props.lastName.hasErrorFocus && {
                          className: "elementFocus",
                        })}
                      />
                    </FormGroup>

                    <FormGroup
                      controlId="formBasicTextEmail"
                      validationState={this.getValidationState(
                        this.props.email.isValid
                      )}
                    >
                      <ControlLabel>
                        Email <strong className="text-red"> *</strong>
                      </ControlLabel>
                      {this.props.showLoader && <Loader />}
                      <FormError
                        id="email-error"
                        hasHtml="true"
                        errorMessage={this.props.email.message}
                      />
                      <FormControl
                        name="email"
                        type="text"
                        value={this.props.email.value}
                        onChange={this.props.handleUserInput}
                        maxLength="45"
                        aria-required="true"
                        aria-describedby="email-error"
                        {...(this.props.email.hasErrorFocus && {
                          className: "elementFocus",
                        })}
                      />
                    </FormGroup>

                    <FormGroup
                      controlId="formBasicTextPassword"
                      validationState={this.getValidationState(
                        this.props.password.isValid
                      )}
                    >
                      <ControlLabel>
                        Password <strong className="text-red"> *</strong>
                      </ControlLabel>
                      <FormError
                        id="password-error"
                        errorMessage={this.props.password.message}
                      />
                      <FormControl
                        name="password"
                        type="password"
                        value={this.props.password.value}
                        onChange={this.props.handleUserInput}
                        maxLength="24"
                        aria-required="true"
                        aria-describedby="password-error"
                        {...(this.props.password.hasErrorFocus && {
                          className: "elementFocus",
                        })}
                      />
                      <HelpBlock>8 Characters Minimum</HelpBlock>
                      <HelpBlock>One lower case</HelpBlock>
                      <HelpBlock>One upper case</HelpBlock>
                      <HelpBlock>One special character</HelpBlock>
                      <HelpBlock>One numeric</HelpBlock>
                      <HelpBlock>
                        Must not have 3 or more sequential/ascending/descending
                        characters
                      </HelpBlock>
                    </FormGroup>

                    <FormGroup
                      controlId="formQuestionAndAnswerFirstContributions"
                      className="fn-devProgram"
                    >
                      <ControlLabel>
                        {this.props.questionAndAnswerContributionsQuestion}
                      </ControlLabel>
                      <br />
                      {this.props.questionAndAnswerContributionsPossibleOptions.map(
                        (possibleOption, index) => {
                          return (
                            <Checkbox
                              key={index}
                              name="questionAndAnswerContributionsSelectedOptions"
                              value={possibleOption}
                              onChange={this.props.handleUserInput}
                              checked={
                                this.props.questionAndAnswerContributionsSelectedOptions.indexOf(
                                  possibleOption
                                ) > -1
                              }
                            >
                              {possibleOption}
                            </Checkbox>
                          );
                        }
                      )}
                    </FormGroup>

                    <FormGroup
                      controlId="formQuestionAndAnswerFirstResponder"
                      className="fn-responder"
                    >
                      <ControlLabel>
                        {this.props.questionAndAnswerFirstResponderQuestion}
                      </ControlLabel>
                      <br />

                      {this.props.questionAndAnswerFirstResponderPossibleAnswers.map(
                        (possibleOption, index) => {
                          return (
                            <Radio
                              key={index}
                              checked={
                                this.props.questionAndAnswerFirstResponderAnswers.indexOf(
                                  possibleOption
                                ) > -1
                              }
                              name="questionAndAnswerFirstResponderAnswers"
                              value={possibleOption}
                              onChange={this.props.handleUserInput}
                            >
                              {possibleOption}
                            </Radio>
                          );
                        }
                      )}
                    </FormGroup>

                    <br />
                    <strong>SUBSCRIPTION PREFERENCES </strong>
                    <FormGroup controlId="newsletterSubscriptionPreferences">
                      <br />
                      <Checkbox
                        inline
                        checked={this.props.newsletterSubscription.value}
                        name="newsletterSubscription"
                        value="newsletterSubscription"
                        onChange={this.props.handleUserInput}
                      >
                        Send me the latest news and exclusive offers from the
                        FirstNet Developer Program (monthly newsletter, API
                        information and updates, program updates, and alerts)
                      </Checkbox>
                    </FormGroup>

                    <FormGroup controlId="eventsSubscriptionPreferences">
                      <br />
                      <Checkbox
                        inline
                        checked={this.props.eventsSubscription.value}
                        name="eventsSubscription"
                        value="eventsSubscription"
                        onChange={this.props.handleUserInput}
                      >
                        Event notifications for upcoming FirstNet Developer
                        Program, Hackathons, and events such as Developer
                        Summit, DevLab, and other sponsored events
                      </Checkbox>
                    </FormGroup>
                    <Link
                      to="/individualTos"
                      className="button primary light-bg variableWidth next"
                      id="continueIndividual"
                      role="button"
                      onClick={this.props.handleIndividualValidation}
                    >
                      Continue
                    </Link>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Individual;



// WEBPACK FOOTER //
// ./src/registration/Individual.js